var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',{staticClass:"app_layout"},[_c('div',{staticClass:"app_layout-content",class:{ 'app_layout-content--has-nav': _vm.isNavVisible }},[_vm._t("default")],2),(_vm.isNavVisible)?_c('VNav'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }